import React, { memo } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import Typography from '@mui/material/Typography';

import { Box, Grid, Link as LinkButton, Container, Button, useTheme } from '@mui/material';

import { truncateText } from '@mais-retorno-front/libs/util-helpers';
import { removeHtml } from '@mais-retorno-front/helpers/format';
import { pathsWithSemanticFooter } from '@mais-retorno-front/constants/paths-with-semantic';
import { IProps } from './model';

import { WordBorder } from './styles';
import { GlossaryLinks } from '../ui-glossary-links';

export const WordOfDaySection = memo<IProps>(
  ({ title = 'Termo do dia', terms }) => {
    const router = useRouter();

    const useSection = pathsWithSemanticFooter.includes(router.asPath);

    const relatedTermsLimited = terms?.related_terms?.slice(0, 4);

    return (
      <Box component={useSection ? 'section' : 'div'} py={8} bgcolor="#F6F6F6">
        <Container maxWidth={false}>
          <Grid container spacing={4}>

            <Grid item xs={12} lg={6}>
              <GlossaryLinks />
            </Grid>

            <Grid item xs={12} lg={6}>
              <Box width="fit-content" position="relative" mb={1}>
                <Link href={terms.link} passHref legacyBehavior prefetch={false}>
                  <Typography
                    variant="h4"
                    component="a"
                    fontWeight={600}
                    dangerouslySetInnerHTML={{
                      __html: removeHtml(terms.title),
                    }}
                  />
                </Link>
                <WordBorder />
              </Box>

              <Typography
                variant="body1"
                component="p"
                style={{ display: 'inline' }}
                dangerouslySetInnerHTML={{
                  __html: removeHtml(truncateText(terms.excerpt, 200)),
                }}
              />

              <Link href={terms.link} passHref legacyBehavior prefetch={false}>
                <LinkButton style={{ fontWeight: 700, textTransform: 'none' }}>
                  &nbsp; Continuar Lendo
                </LinkButton>
              </Link>


              {
                relatedTermsLimited?.length > 0 && (
                  <Box mt={6}>
                    <Typography fontWeight={700} component="h3" variant="body1">
                      Mais termos relacionados:
                    </Typography>

                    <Box>
                      {relatedTermsLimited.map((related) => (
                        <Button
                          component="a"
                          target="_blank"
                          href={related.link}
                          LinkComponent={Link}
                          variant="outlined"
                          color="primary"
                          sx={{
                            textTransform: 'none',
                            margin: 0.5
                          }}
                        >
                          {
                            related.title
                          }
                        </Button>
                      ))}
                    </Box>
                  </Box>
                )
              }
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }
);
